import { Component } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { GalleriaModule } from 'primeng/galleria';
import { MainGalleryComponent } from '../gallery/main-gallery/main-gallery.component';
// import { SearchWidgetComponent } from 'src/app/components/karve/search-widget/search-widget.component';
// import { Router } from '@angular/router';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [CarouselModule, GalleriaModule, MainGalleryComponent],

  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  logoSrc = 'logo.jpg';
  images: string[] = [
    'assets/img/temp/Imagen1.jpg',
    'assets/img/temp/Imagen2.jpg',
  ];

  // constructor(private router: Router) {
  //   if (['/furgonetas', '/vans'].includes(this.router.url)) {
  //     this.logoSrc = 'logo.jpg';
  //   }
  // }
}
